import { VITE_USE_MOCK, VITE_MOCK_API, VITE_SEARCH_FILTER_URL } from 'Constants/appEnvConstants'

export default function getSearchFilterUrl() {
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_SEARCH_FILTER_URL; // eslint-disable-line no-undef
}
